import { render } from "./CIS-Hardened-Images-Cloud-Provider-List.vue?vue&type=template&id=3e073cc8&scoped=true"
import script from "./CIS-Hardened-Images-Cloud-Provider-List.vue?vue&type=script&lang=js"
export * from "./CIS-Hardened-Images-Cloud-Provider-List.vue?vue&type=script&lang=js"

import "./CIS-Hardened-Images-Cloud-Provider-List.vue?vue&type=style&index=0&id=3e073cc8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e073cc8"]])

export default __exports__